module.exports = __webpack_public_path__ + "img/grid-white.463e3d2d.svg";